import { useCallback, useMemo } from 'react';
import { FormName } from 'presentation/forms';
import { useUiActions } from 'store/ui';

type SetEditing = (isFormEditing: boolean, form: FormName) => void;
type ClearAllForms = () => void;
export interface FormEdit {
  setEditing: SetEditing;
  clearAllForms: ClearAllForms;
}
const useFormEdit = (): FormEdit => {
  const { setFormEditing, clearFormsEditing } = useUiActions();

  const setEditing: SetEditing = useCallback(
    (isFormEditing: boolean, form: FormName): void => {
      setFormEditing(form, isFormEditing);
    },
    [setFormEditing]
  );

  const clearAllForms = useCallback((): void => {
    clearFormsEditing();
  }, [clearFormsEditing]);

  return useMemo(
    (): FormEdit => ({
      setEditing,
      clearAllForms,
    }),
    [setEditing, clearAllForms]
  );
};

export default useFormEdit;
